export default __webpack_public_path__ + "static/media/inactive-hcp-legend-icon-new.326d1172.svg";